define.alias("shared/components/shared/app-footer", "media/components/shared/app-footer");